/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getInvitations({ params, isCurrentAgency, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  if (isCurrentAgency) {
    headers["x-agency-id"] = store.getters['agency/currentAgencyId'];
  }

  return axios.get("/invitations", { headers, params, signal });
}

export function sendInvitation({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  
  return axios.post("/invitations", payload, { headers });
}

export function getInvitation({ inviteId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/invitations/${inviteId}`, { headers, signal });
}

export function fulfillInvitation({ inviteId, agencyId, payload }) {
  const currentAgencyId = agencyId ? agencyId : store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": currentAgencyId,
  };

  return axios.put(`/invitations/${inviteId}`, payload, { headers });
}

export function revokeInvitation({ inviteId, agencyId }) {
  const currentAgencyId = agencyId ? agencyId : store.getters['agency/currentAgencyId'];
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": currentAgencyId,
  };

  return axios.delete(`/invitations/${inviteId}`, { headers });
}

export function resendInvitation({ inviteId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post(`/invitations/${inviteId}/resend`, {}, { headers });
}
